import { Dialog, DialogContentText, DialogTitle, DialogContent } from '@mui/material';
import React from 'react';
import getDate from "../../../../utils/getDate";

export default function RejectReasonDialog({ rejectReasonOpen, handleRejectReasonClose, model}) {
  return (
    <Dialog
      open={rejectReasonOpen}
      onClose={handleRejectReasonClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Reason:
      </DialogTitle>
      <DialogContent sx={{ minWidth: '500px' }}>
        {model.m2dModelRejects.map(rej => {
          return (
            <DialogContentText key={rej.id}>
              {getDate(rej.time)}: {rej.rejectReason}
            </DialogContentText>
          )
        })}
      </DialogContent>
    </Dialog>
  )
}
